// import { FaFacebook } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
// import { FaInstagramSquare } from "react-icons/fa";
// import { FaYoutube } from "react-icons/fa";

// export default function Footer() {
//   const socials = [
//     {
//       icon: <FaFacebook />,
//       link: "https://facebook.com",
//     },
//     {
//       icon: <FaTwitter />,
//       link: "https://twitter.com",
//     },
//     {
//       icon: <FaInstagramSquare />,
//       link: "https://instagram.com",
//     },
//     {
//       icon: <FaYoutube />,
//       link: "https://youtube.com",
//     },
//   ];

//   const contact = {
//     address1: "Near Burger King opposite Shiv Mandir, JhaJhanpur",
//     address2: "Moradabad, Uttar Pradesh - 244001",
//     phone1: "+91 9258658787",
//     phone2: "+91 8881555644",
//     email: "superstrengcable@gmail.com",
//     gst: "09HBKPD6866F1Z7",
//   };

//   return (
//     <footer className="relative bg-black text-white pt-24 overflow-hidden">
//       {/* background glow */}
//       <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-lime-500/10 blur-[120px]" />
//       <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-purple-500/10 blur-[120px]" />

//       <div className="relative max-w-7xl mx-auto px-6">
//         {/* GRID */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
//           {/* ABOUT */}
//           <div>
//             <h3 className="text-xl font-bold uppercase tracking-wide mb-4 text-white">
//               About Us
//             </h3>

//             <p className="text-gray-400 leading-7 text-sm">
//               We specialize in high-performance bike modification, servicing,
//               and custom builds focused on speed, safety, and precision.
//             </p>

//             {/* social */}
//             <div className="flex gap-4 mt-6">
//               {socials.map((item, index) => (
//                 <a
//                   key={index}
//                   href={item.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:text-black hover:bg-lime-400 hover:border-lime-400 transition"
//                 >
//                   <i className={item.icon}></i>
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* QUICK LINKS */}
//           <div>
//             <h3 className="text-xl font-bold uppercase tracking-wide mb-4">
//               Quick Links
//             </h3>

//             <ul className="space-y-3 text-gray-400 text-sm">
//               {[
//                 { name: "Home", link: "/cable/" },
//                 { name: "Works", link: "/cable/pages/work.html" },
//                 { name: "Services", link: "/cable/pages/service.html" },
//                 { name: "Contact", link: "/cable/pages/contact.html" },
//               ].map((item, i) => (
//                 <li key={i}>
//                   <a
//                     href={item.link}
//                     className="hover:text-lime-400 transition"
//                   >
//                     {item.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* SERVICES */}
//           <div>
//             <h3 className="text-xl font-bold uppercase tracking-wide mb-4">
//               Services
//             </h3>

//             <ul className="space-y-3 text-gray-400 text-sm">
//               {[
//                 "Brake Cable Systems",
//                 "Gear Cable Systems",
//                 "Custom Bike Setup",
//                 "Performance Tuning",
//               ].map((service, i) => (
//                 <li
//                   key={i}
//                   className="hover:text-white transition cursor-default"
//                 >
//                   {service}
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* CONTACT */}
//           <div>
//             <h3 className="text-xl font-bold uppercase tracking-wide mb-4">
//               Contact
//             </h3>

//             <div className="space-y-3 text-gray-400 text-sm">
//               <p>{contact.address1}</p>
//               <p>{contact.address2}</p>

//               <p>
//                 <span className="text-white">Phone:</span> {contact.phone1} /{" "}
//                 {contact.phone2}
//               </p>

//               <p>
//                 <span className="text-white">Email:</span> {contact.email}
//               </p>

//               <p>
//                 <span className="text-white">GST:</span> {contact.gst}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* DIVIDER */}
//         <div className="mt-16 border-t border-white/10" />

//         {/* BOTTOM BAR */}
//         <div className="py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-center">
//           <p className="text-gray-500 text-sm">
//             © {new Date().getFullYear()} Super Strength Bikes. All Rights
//             Reserved.
//           </p>

//           <p className="text-gray-600 text-xs tracking-widest uppercase">
//             Built for Performance Riders ⚡
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// }

import {
  FaFacebook,
  FaTwitter,
  FaInstagramSquare,
  FaYoutube,
} from "react-icons/fa";

const socials = [
  { Icon: FaFacebook, link: "https://facebook.com" },
  { Icon: FaTwitter, link: "https://twitter.com" },
  { Icon: FaInstagramSquare, link: "https://instagram.com" },
  { Icon: FaYoutube, link: "https://youtube.com" },
];

const links = [
  { name: "Home", link: "/cable/" },
  { name: "Works", link: "/cable/pages/work.html" },
  { name: "Services", link: "/cable/pages/service.html" },
  { name: "Contact", link: "/cable/pages/contact.html" },
];

const services = [
  { name: "Brake Cable Systems", link: "/service" },
  { name: "Gear Cable Systems", link: "/service" },
  { name: "Custom Bike Setup", link: "/service" },
  { name: "Performance Tuning", link: "/service" },
];

const contact = {
  address1: "Near Burger King opposite Shiv Mandir, JhaJhanpur",
  address2: "Moradabad, Uttar Pradesh - 244001",
  phone1: "+91 9258658787",
  phone2: "+91 8881555644",
  email: "superstrengcable@gmail.com",
  gst: "09HBKPD6866F1Z7",
};

export default function Footer() {
  return (
    <footer className="relative bg-black text-white py-4 overflow-hidden">
      {/* glow effects */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-lime-500/10 blur-[120px]" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-purple-500/10 blur-[120px]" />

      <div className="relative max-w-7xl mx-auto px-6">
        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* ABOUT */}
          <div>
            <h3 className="text-xl font-bold mb-5">About Us</h3>

            <p className="text-gray-300 text-sm leading-7">
              We specialize in high-performance bike modification, servicing,
              and custom builds focused on speed, safety, and precision.
            </p>

            <div className="flex gap-4 mt-6">
              {socials.map(({ Icon, link }, i) => (
                <a
                  key={i}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" flex items-center justify-center w-10 h-10 rounded-full border border-gray-700
                 text-gray-300 hover:text-white hover:border-white
                 transition-all duration-300 hover:scale-110"
                >
                  <Icon size={25} />
                </a>
              ))}
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="text-xl font-bold mb-5">Quick Links</h3>

            <ul className="space-y-3 text-gray-300 text-sm">
              {links.map((item, i) => (
                <li key={i}>
                  <a
                    href={item.link}
                    className="hover:text-lime-400 transition-all duration-200 hover:pl-1"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* SERVICES */}
          <div>
            <h3 className="text-xl font-bold mb-5">Services</h3>

            <ul className="space-y-3 text-gray-300 text-sm">
              {services.map((service, i) => (
                <li key={i}>
                  <a
                    href={service.link}
                    className="hover:text-white transition-all duration-200 hover:pl-1"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="text-xl font-bold mb-5">Contact</h3>

            <div className="space-y-3 text-gray-300 text-sm">
              <p>{contact.address1}</p>
              <p>{contact.address2}</p>

              <p>
                <span className="text-white font-medium">Phone:</span>{" "}
                {contact.phone1} / {contact.phone2}
              </p>

              <p>
                <span className="text-white font-medium">Email:</span>{" "}
                {contact.email}
              </p>

              <p>
                <span className="text-white font-medium">GST:</span>{" "}
                {contact.gst}
              </p>
            </div>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="mt-5 border-t border-white/10" />

        {/* BOTTOM */}
        <div className="pt-3 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Super Strength Bikes
          </p>

          <p className="text-gray-600 text-xs uppercase tracking-widest">
            Built for Performance Riders ⚡
          </p>
        </div>
      </div>
    </footer>
  );
}
